/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
export { default as DotsItem } from './DotsItem';
export * from './DotsItem';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nivo/core/es/components/dots/index.js
// module id = 1380
// module chunks = 0